import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { devInfoSelector } from "../../store/selectors";

function getQueryParam(search, param) {
  const params = new URLSearchParams(search);
  return params.get(param);
}

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  // const { isDev } = useSelector(devInfoSelector);

  useEffect(async () => {
    const token = getQueryParam(location.search, "access_token");

    if (token) {
      const success = await login(token);
      if (success && window.location.href.includes("/auth/success")) {
        window.location.href = "https://go.7cut.video";
      }
      // if (isDev) {
      //   window.location.href = "https://localhost:8080";
      // } else {
      //   window.location.href = "https://go.7cut.video";
      // }
    }

    return;
  }, [location, login, navigate, dispatch]);

  return <div>{error ? error : "Logging in..."}</div>;
};

export default AuthCallback;
